// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/types/v1/assay_type.proto (package quanterix.common.types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/common/types/v1/assay_type.proto.
 */
export const file_quanterix_common_types_v1_assay_type: GenFile = /*@__PURE__*/
  fileDesc("CipxdWFudGVyaXgvY29tbW9uL3R5cGVzL3YxL2Fzc2F5X3R5cGUucHJvdG8SGXF1YW50ZXJpeC5jb21tb24udHlwZXMudjEqogEKCUFzc2F5VHlwZRIaChZBU1NBWV9UWVBFX1VOU1BFQ0lGSUVEEAASHAoYQVNTQVlfVFlQRV9RVUFOVEVSSVhfS0lUEAESHAoYQVNTQVlfVFlQRV9JTk5PVkFUT1JfS0lUEAISHAoYQVNTQVlfVFlQRV9BRE1JTl9ERUZJTkVEEAMSHwobQVNTQVlfVFlQRV9RVUFOVEVSSVhfQ1VTVE9NEARiBnByb3RvMw");

/**
 * Represents a predefined assay type (e.g. a commercial kit)
 *
 * @remarks
 * This type is equivalent to quanterix.protos.type.AssayType
 *
 * @generated from enum quanterix.common.types.v1.AssayType
 */
export enum AssayType {
  /**
   * Unspecified type (default)
   *
   * @generated from enum value: ASSAY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Predefined kits defined by Quanterix
   *
   * @generated from enum value: ASSAY_TYPE_QUANTERIX_KIT = 1;
   */
  QUANTERIX_KIT = 1,

  /**
   * Customized assay kits, formerly "homebrew"
   *
   * @generated from enum value: ASSAY_TYPE_INNOVATOR_KIT = 2;
   */
  INNOVATOR_KIT = 2,

  /**
   * Assay defined kits
   *
   * @generated from enum value: ASSAY_TYPE_ADMIN_DEFINED = 3;
   */
  ADMIN_DEFINED = 3,

  /**
   * Miscellaneous assay kits
   *
   * @generated from enum value: ASSAY_TYPE_QUANTERIX_CUSTOM = 4;
   */
  QUANTERIX_CUSTOM = 4,
}

/**
 * Describes the enum quanterix.common.types.v1.AssayType.
 */
export const AssayTypeSchema: GenEnum<AssayType> = /*@__PURE__*/
  enumDesc(file_quanterix_common_types_v1_assay_type, 0);

